import React from 'react';

// UDRAW-S5.1 §2.2.4 — the visible half of `fieldEditing`. Renders a
// pulsing dot + "<fullName> is editing…" next to the affected field's
// label when a peer's active broadcast landed for that (anchor,
// fieldKey). Silent when `peer` is falsy.
//
// The indicator is deliberately unobtrusive — small text, no border,
// no background. It sits inline after the label so it doesn't push
// the field down. Two data-testids to make assertions surgical:
//   `${fieldKey}-editing-indicator` — the wrapper (present iff shown).
//   `${fieldKey}-editing-name`      — the peer's full name.
export default function FieldEditingIndicator({ fieldKey, peer }) {
  if (!peer || !peer.fullName) return null;
  return (
    <span
      data-testid={`${fieldKey}-editing-indicator`}
      style={{
        marginLeft: 8, fontSize: 11, color: '#8a6a12',
        display: 'inline-flex', alignItems: 'center', gap: 4,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 6, height: 6, borderRadius: '50%',
          background: '#e0a52f',
          animation: 'udrawLiveEditingPulse 1.4s ease-in-out infinite',
        }}
      />
      <span data-testid={`${fieldKey}-editing-name`}>{peer.fullName}</span>
      <span>&nbsp;is editing…</span>
      <style>{`@keyframes udrawLiveEditingPulse {
        0%   { opacity: 0.35; transform: scale(0.85); }
        50%  { opacity: 1;    transform: scale(1.15); }
        100% { opacity: 0.35; transform: scale(0.85); }
      }`}</style>
    </span>
  );
}
